import {
  AUTH_LOGIN,
  AUTH_REQUEST,
  AUTH_SUCCESS,
  AUTH_FAILURE,
  AUTH_REFRESH,
  AUTH_LOGOUT,
  AUTH_CHECK_USERNAME,
  AUTH_REGISTER,
  AUTH_REGISTER_SOCIAL,
  AUTH_CHECK_CRED,
  AUTH_SIGNED_URL_GET,
  AUTH_FIND_ID,
  AUTH_REQUEST_TEMPORARY_PASSWORD,
  AUTH_SEND_EMAIL_VERIFICATION,
  AUTH_VERIFY_EMAIL,
  AUTH_GET_IMP_INFO,
  AUTH_REGISTER_UNICOL
} from '@/store/types'

import axios from '@/store/axios'

/* TODO: @stan, 
  Refactor keyMapper values as global constant and 
  methods for converting from and to
*/
const keyMapper = {
  loginId: 'username',
  loginNm: 'name',
  memberId: 'id'
}

// Set current selected library as default library
const state = {
  user: null,
  isLoading: false,
  error: null,
  signedUrl: null
}

const getters = {
  isAuthLoading: (state) => state.isLoading,
  getCurrentUser: (state) => state.user,
  getAuthErrorMessage: (state) =>
    state.error?.response
      ? `${state.error.response.data.errorState.message}`
      : state.error,
  getAuthSignedUrl: (state) => state.signedUrl
}

const actions = {
  [AUTH_GET_IMP_INFO]: ({ commit }, payload) => {
    commit(AUTH_REQUEST)
    return new Promise((resolve, reject) => {
      axios
        .get(`/authenticate/register/iamport/${payload}`)
        .then((res) => {
          resolve(res)
          commit(AUTH_SUCCESS)
        })
        .catch((err) => {
          reject(err)
          commit(AUTH_FAILURE, err)
        })
    })
  },
  [AUTH_LOGIN]: ({ commit }, { username, password }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)

      axios
        .post(`/authenticate/login`, {
          authentication: {
            loginId: btoa(username),
            loginPwd: btoa(password)
          }
        })
        .then((resp) => {
          const token = resp.data.result.authToken
          localStorage.setItem('token', token)

          commit(AUTH_SUCCESS, { user: resp.data.result })
          resolve(resp)
        })
        .catch((err) => {
          const errorCode = err?.response?.data?.errorState?.code
          if (errorCode == 2025 || errorCode == 2033 || errorCode == 6003) {
            commit(AUTH_FAILURE, err)
          } else {
            commit(
              AUTH_FAILURE,
              '로그인 에러. 상태가 지속되면 캠퍼스북 카카오톡으로 문의해주세요.'
            )
          }
          reject(err)
        })
    })
  },
  [AUTH_CHECK_CRED]: ({ commit }, { impUid }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)

      axios
        .post('/member/authenticate/verify', {
          authentication: {
            impUid: impUid
          }
        })
        .then((resp) => {
          commit(AUTH_SUCCESS, {})
          resolve(resp)
        })
        .catch((err) => {
          commit(AUTH_FAILURE, err)
          reject(err)
        })
    })
  },
  [AUTH_LOGOUT]: ({ commit }) => {
    commit(AUTH_REQUEST)
    return new Promise((resolve, reject) => {
      axios
        .delete(`/authenticate/logout`)
        .then((resp) => {
          localStorage.removeItem('token')
          commit(AUTH_LOGOUT)
          resolve(resp)
        })
        .catch((err) => {
          commit(AUTH_LOGOUT)
          commit(AUTH_FAILURE, err)
          reject(err)
        })
    })
  },
  [AUTH_CHECK_USERNAME]: ({ commit }, username) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)

      axios
        .post(`/authenticate/verify/duplicate-id/`, {
          authentication: {
            loginId: btoa(username)
          }
        })
        .then((resp) => {
          commit(AUTH_SUCCESS, {})
          resolve(resp)
        })
        .catch((err) => {
          commit(AUTH_FAILURE, err)
          reject(err)
        })
    })
  },
  [AUTH_REGISTER]: ({ commit }, { data }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      axios
        .post(`/authenticate/register/`, { authentication: data })
        .then((resp) => {
          const token = resp.data.result.authToken
          localStorage.setItem('token', token)

          commit(AUTH_SUCCESS, { user: resp.data.result })
          resolve(resp)
        })
        .catch((err) => {
          commit(AUTH_FAILURE, err)
          reject(err)
        })
    })
  },
  [AUTH_REGISTER_SOCIAL]: ({ commit }, { data, sessionId }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      axios
        .post(`/authenticate/social-register?sessionId=${sessionId}`, {
          authentication: data
        })
        .then((resp) => {
          const token = resp.data.result.authToken
          localStorage.setItem('token', token)

          commit(AUTH_SUCCESS, { user: resp.data.result })
          resolve(resp)
        })
        .catch((err) => {
          commit(AUTH_FAILURE, err)
          reject(err)
        })
    })
  },
  [AUTH_REGISTER_UNICOL]: ({ commit }, { data, memberId }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      axios
        .put(`/authenticate/register/unicol/update`, {
          authentication: data,
          member: { memberId: memberId }
        })
        .then((resp) => {
          commit(AUTH_SUCCESS, {})
          resolve(resp)
        })
        .catch((err) => {
          commit(AUTH_FAILURE, err)
          reject(err)
        })
    })
  },
  [AUTH_REFRESH]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)

      axios
        .get(`/authenticate/token/issue`)
        .then((resp) => {
          const token = resp.data.result.authToken
          localStorage.setItem('token', token)
          commit(AUTH_SUCCESS, { user: resp.data.result })
          resolve(resp)
        })
        .catch((err) => {
          commit(AUTH_FAILURE, err)
          reject(err)
        })
    })
  },
  [AUTH_SIGNED_URL_GET]: ({ commit }, { type, fileSize, fileName }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)

      axios
        .get(`/auth/presigned/${type}`, { params: { fileSize, fileName } })
        .then((resp) => {
          commit(AUTH_SUCCESS, { signedUrl: resp.data.result.presignedUrl })
          resolve(resp)
        })
        .catch((err) => {
          commit(AUTH_FAILURE, err)
          reject(err)
        })
    })
  },
  [AUTH_FIND_ID]: ({ commit }, { findTp, email, phone, impUid }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      const payload = {
        findTp
      }

      if (findTp === 'phone') {
        payload.mobileNo = phone
        payload.impUid = impUid
      } else {
        payload.email = email
      }

      axios
        .post('/authenticate/find-id/', { authentication: payload })
        .then((resp) => {
          commit(AUTH_SUCCESS, {})
          resolve(resp)
        })
        .catch((err) => {
          commit(AUTH_FAILURE, err)
          reject(err)
        })
    })
  },
  [AUTH_REQUEST_TEMPORARY_PASSWORD]: (
    { commit },
    { findTp, email, phone, impUid, loginNm, loginId }
  ) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      const payload = {
        findTp,
        loginNm
      }

      if (findTp === 'phone') {
        payload.mobileNo = phone
        payload.impUid = impUid
        payload.email = loginId
      } else {
        payload.email = email
      }

      axios
        .post('/authenticate/find-pwd/', { authentication: payload })
        .then((resp) => {
          commit(AUTH_SUCCESS, {})
          resolve(resp)
        })
        .catch((err) => {
          commit(AUTH_FAILURE, err)
          reject(err)
        })
    })
  },
  [AUTH_SEND_EMAIL_VERIFICATION]: ({ commit }, email) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)

      axios
        .post('customer/authenticate/verify/email/', {
          authentication: {
            email: btoa(email)
          }
        })
        .then((resp) => {
          commit(AUTH_SUCCESS, {})
          resolve(resp)
        })
        .catch((err) => {
          commit(AUTH_FAILURE, err)
          reject(err)
        })
    })
  },
  [AUTH_VERIFY_EMAIL]: ({ commit }, { email, code }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)

      axios
        .put('/customer/authenticate/email/result/', {
          authentication: {
            email: btoa(email),
            authNo: code
          }
        })
        .then((resp) => {
          commit(AUTH_SUCCESS, {})
          resolve(resp)
        })
        .catch((err) => {
          commit(AUTH_FAILURE, err)
          reject(err)
        })
    })
  }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.isLoading = true
  },
  [AUTH_SUCCESS]: (state, { user, signedUrl }) => {
    state.isLoading = false

    if (user) {
      Object.keys(user).map((key) => {
        if (keyMapper[key]) {
          user[keyMapper[key]] = user[key]
        }
      })
      state.user = user
    }
    if (signedUrl) state.signedUrl = signedUrl
  },
  [AUTH_FAILURE]: (state, err) => {
    state.isLoading = false
    state.error = err
  },
  [AUTH_LOGOUT]: (state) => {
    state.isLoading = false
    state.user = null
  },
  // 로그인 페이지 에러메세지 초기화
  RESET_AUTH_ERROR(state) {
    state.error = null // 또는 state.error = ''와 같이 초기값으로 설정
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
